import getActionName from '../../utils/getActionName';

export const createLoadingSelector = (action) => (state) => {
    if (
        state?.ui?.loading[getActionName(action)] &&
        state?.ui?.loading[getActionName(action)]?.pending
    ) {
        return state?.ui?.loading[getActionName(action)]?.pending;
    }
    return false;
};
